/*
import React, { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import "../styles/Sidebar.css";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate("/");
  };

  return (
    <Menu isOpen={isOpen} onStateChange={({ isOpen }) => setIsOpen(isOpen)}>
      <img
        src="/images/patientManager2.svg"
        alt="Logo Patient Manager"
        className="logoMenu"
      />

      <a
        className="menu-item"
        onClick={() => handleNavigate("/patients")}
        role="button"
        style={{ cursor: "pointer" }}
      >
        Gestión de pacientes
      </a>

      <a
        className="menu-item"
        onClick={() => handleNavigate("/account")}
        role="button"
        style={{ cursor: "pointer" }}
      >
        Mi perfil
      </a>

      <a
        className="menu-item"
        onClick={handleLogout}
        role="button"
        style={{ cursor: "pointer" }}
      >
        Salir
      </a>
    </Menu>
  );
}

export default Sidebar;
*/

/*
import React, { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import "../styles/Sidebar.css";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate("/");
  };

  return (
    <Menu isOpen={isOpen} onStateChange={({ isOpen }) => setIsOpen(isOpen)}>
      <img
        src="/images/patientManager2.svg"
        alt="Logo Patient Manager"
        className="logoMenu"
      />

      <button
        type="button"
        className="menu-item"
        onClick={() => handleNavigate("/patients")}
      >
        Gestión de pacientes
      </button>

      <button
        type="button"
        className="menu-item"
        onClick={() => handleNavigate("/account")}
      >
        Mi perfil
      </button>

      <button type="button" className="menu-item" onClick={handleLogout}>
        Salir
      </button>
    </Menu>
  );
}

export default Sidebar;
*/

import React, { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import "../styles/Sidebar.css";
import { useAuth } from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";

function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Menu isOpen={isOpen} onStateChange={({ isOpen }) => setIsOpen(isOpen)}>
      <div className="sidebarHeader">
        <img
          src="/images/patientManager2.svg"
          alt="Logo Patient Manager"
          className="logoMenu"
        />
      </div>

      <nav className="sidebarNav" aria-label="Menú">
        <button
          type="button"
          className={`menu-item ${isActive("/patients") ? "is-active" : ""}`}
          onClick={() => handleNavigate("/patients")}
        >
          Gestión de pacientes
        </button>

        <button
          type="button"
          className={`menu-item ${isActive("/account") ? "is-active" : ""}`}
          onClick={() => handleNavigate("/account")}
        >
          Mi perfil
        </button>
      </nav>

      <div className="sidebarFooter">
        <button
          type="button"
          className="menu-item menu-item--logout"
          onClick={handleLogout}
        >
          Cerrar sesión
        </button>
      </div>
    </Menu>
  );
}

export default Sidebar;
